import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Laoder from "../../../Loader";
import { getRequestByAuth } from "../../../../../../function/helper";
import style from "./SearchAddress.module.css";

function SearchAddress({ senderOrgetther, setAddress, close, setNewAddress }) {
  const url = `/address/v1/search/${senderOrgetther}/`;
  const [key, setKey] = useState("");
  const [listAddress, setListAddress] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const getAddress = async () => {
    setListAddress([]);
    if (key.length > 3) {
      setSearchLoading(true);
      const reponse = await getRequestByAuth(url + key);
      setSearchLoading(false);

      if (reponse) {
        if (reponse.status === 200) {
          setListAddress(reponse.data);
        }
      }
    }
  };

  useEffect(() => {
    const timeOut = setTimeout(getAddress, 1100);
    return () => clearTimeout(timeOut);
  }, [key]);

  return (
    <Modal show={true} size="lg">
      <Modal.Header>
        <h4>
          <span>جستجو از آدرس های </span>
          <span>{senderOrgetther === 1 ? "گیرنده" : "فرستنده"}</span>
          <span> قبلی</span>
        </h4>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>جستجوی آدرس (حداقل چهار کاراکتر الزامی است)</Form.Label>
        <Form.Control
          type="text"
          autoFocus
          onChange={e => setKey(e.target.value)}
        />
        {searchLoading && <Laoder />}
        <div className={style.containter}>
          {listAddress.map((item, idx) => (
            <button
              key={idx}
              className="btn btn-light w-100 py-1 px-2 my-1"
              onClick={() => {
                setAddress(item);
                close();
              }}
            >
              {item.address.country_name.faName} -{" "}
              {item.address.province_name.faName} -{" "}
              {item.address.city_name.faName} - {item.address.totalAddress} -{" "}
              {item.address.compony} - {item.address.phone}
            </button>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-cancel-style"
          onClick={() => {
            setListAddress([]);
            close();
          }}
        >
          بستن
        </button>
        <button
          className="btn-success-style"
          onClick={() => {
            setNewAddress();
            close();
          }}
        >
          ثبت آدرس جدید
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default SearchAddress;
